import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    adminlogedin:false
}

const auth = createSlice({
    name:'auth',
    initialState,
    reducers: {
        adminlog: (state, action) =>{
           if(action.payload === true){
             state.adminlogedin = true;
           }else{
            state.adminlogedin = false;
           }
        }
    }
})

export const { adminlog } = auth.actions;
export default auth.reducer;